interface Param {
  api: string;
  method?: string;
  data?: any;
  skipParse?: boolean;
  /**
   * 判断接口是否请求成功的日志，跳过 success 字段检查
   */
  skipSuccessCheck?: boolean;
}

function query(param: Param) {
  const { api, method, data } = param;
  let path = api;

  const init = {
    method: (method || 'GET').toUpperCase(),
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (init.method === 'GET') {
    if (data) {
      // get 请求需要把参数拼接到 path 后面
      const query = new URLSearchParams(data).toString();

      path = `${path}?${query}`;
    }
  } else if (data) {
    // @ts-ignore
    init.body = JSON.stringify(data);
  }

  // @ts-ignore
  const ret = fetch(path, init).then(async (resp) => {
    if (resp.status !== 200) {
      return Promise.reject(resp);
    }

    if (param.skipParse) {
      return await resp.text();
    }
    const jsonResp = await resp.json();

    if (jsonResp && typeof jsonResp.code === 'number' && jsonResp.code === 401) {
      // 这里是飞书校验失败，直接刷新页面
      alert('登录状态已失效，即将刷新页面');
      window.location.reload();
    }
    return jsonResp;
  });

  return ret;
}

export interface IParam<T> {
  api: string;
  method?: string;
  data?: T;
  skipParse?: boolean;
  /**
   * 判断接口是否请求成功的日志，跳过 success 字段检查
   */
  skipSuccessCheck?: boolean;
}

/**
 * 这个方法不会做数据异常处理
 * 仅 INVALID_TOKEN 时会出一个 Toast
 * response status === 200 且 数据返回为 json 时，这个方法就会 resolve
 */
export function Request<Param = any, Data = any>(param: IParam<Param>): Promise<Data> {
  return Promise.race([
    new Promise<any>((resolve, reject) => {
      query(param)
        .then((res: any) => {
          resolve(res);
        })
        .catch(reject);
    }),
    new Promise((_, reject) => setTimeout(() => reject(new Error(`fetch ${param.api} timeout`)), 30_000)),
  ]);
}
